export default __webpack_public_path__ + "bar-chart-light.46179f0d.svg";